<template>
  <div class="pt-1 pr-1 pl-1">
    <div class="no-gutters mt-1 ml-3 mr-3">
      <!--<div class="row mb-2">
        <div class="col-md-12">
          <b-button class="btn btn-xs" variant="secondary" v-on:click="alert('test')">Ping</b-button>
          <b-button class="btn btn-xs ml-1" variant="secondary">Request state</b-button>
          <b-button class="btn btn-xs ml-1" variant="secondary">Enable USBL</b-button>
          <b-button class="btn btn-xs ml-1" variant="secondary">Update position</b-button>
          <b-button class="btn btn-xs ml-1" variant="secondary">Send new configuration</b-button>
          <b-button class="btn btn-xs ml-1" variant="danger"><strong>Open releaser</strong></b-button>
        </div>
      </div>-->
      <div class="row">
        <div class="col">
          <div class="parameter-box">
            <h4 v-b-popover.hover.bottom="latitude + ', ' + longitude">{{ position }}</h4>
            <div class="parameter-name">Current position</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-7">
          <div class="parameter-box">
            <h4>{{ dive_stage }}</h4>
            <div class="parameter-name">Dive stage</div>
          </div>
        </div>
        <div class="col-5">
          <div class="parameter-box">
            <h4>{{ releaser_state }}</h4>
            <div class="parameter-name">Releaser state</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-7">
          <div class="parameter-box">
            <h4>
              {{ showDigits(roundDigits(depth, 1), 1) }} <small>m</small>
              <font-awesome-icon v-if="velocity_z < 0" size="sm" class="ml-1 align-baseline" :icon="['fas', 'long-arrow-alt-up']" />
              <font-awesome-icon v-if="velocity_z > 0" size="sm" class="ml-1 align-baseline" :icon="['fas', 'long-arrow-alt-down']" />
              <span v-if="velocity_z !== 0" class="text-muted align-middle velocity-z">
                {{ roundDigits(Math.abs(velocity_z), 1) }} <small>m/s</small>
              </span>
            </h4>
            <div class="parameter-name">Depth</div>
          </div>
        </div>
        <div class="col-4">
          <div class="parameter-box">
            <h4>
              {{ showDigits(roundDigits(battery_voltage, 1), 1) }} <small>V</small>
              <font-awesome-icon class="text-success align-baseline" rotation="270" size="xs" v-if="battery_voltage > 25" :icon="['fas', 'battery-full']" />
              <font-awesome-icon class="text-success align-baseline" rotation="270" size="xs" v-else-if="battery_voltage > 22 && battery_voltage <= 25" :icon="['fas', 'battery-three-quarters']" />
              <font-awesome-icon class="text-warning align-baseline" rotation="270" size="xs" v-else-if="battery_voltage > 20 && battery_voltage <= 22" :icon="['fas', 'battery-half']" />
              <font-awesome-icon class="text-warning align-baseline" rotation="270" size="xs" v-else-if="battery_voltage > 18 && battery_voltage <= 20" :icon="['fas', 'battery-quarter']" />
              <font-awesome-icon class="text-danger align-baseline" rotation="270" size="xs" v-else-if="battery_voltage < 18" :icon="['fas', 'battery-empty']" />
            </h4>
            <div class="parameter-name">Battery voltage</div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-gutters mt-3 mb-3 ml-4 mr-4">
      <div class="row">
        <div class="col-md-3">
          <div class="state-box" :class="getStateStyle(battery_warning)">
            Battery
          </div>
        </div>
        <div class="col-md-3">
          <div class="state-box" :class="getStateStyle(modem_error)">
            Modem
          </div>
        </div>
        <div class="col-md-3">
          <div class="state-box" :class="getStateStyle(depth_error)">
            Pressure
          </div>
        </div>
        <div class="col-md-3">
          <div class="state-box" :class="getStateStyle(software_error)">
            Software
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Helpers from '@/mixins/helpers'

export default {
  name: 'TransponderStatusWidget',
  mixins: [
    Helpers
  ],
  data: function () {
    return {}
  },
  props: ['platformId'],
  methods: {
    getStateStyle: function (state) {
      if (state === 'True') { // FIXME: Proper comparison
        return 'state-danger'
      } else {
        return 'state-ok'
      }
    },
    rotateArrow: function (heading) {
      return 'rotate(' + Number(Number(heading) - 45) + 'deg)'
    },
    getParameterDiff: function (entityId, parameterId) {
      // FIXME: Export to datamodel
      const current = this.getParameterValue(entityId, parameterId, true)
      const last = this.getParameterValue(entityId, parameterId, false)
      if (current > last) {
        return 1
      } else if (current < last) {
        return -1
      } else {
        return 0
      }
    }
  },
  computed: {
    ...mapState(['platforms']),
    ...mapGetters(['currentUpdate', 'lastUpdate']),
    position () {
      const position = this.getCoordinatesNautical(this.roundDigits(this.latitude, 5),
        this.roundDigits(this.longitude, 5))
      return position.lat + ' ' + position.lng
    },
    latitude () {
      const update = this.currentUpdate(this.platformId, 1, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    longitude () {
      const update = this.currentUpdate(this.platformId, 1, 2)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    depth () {
      const update = this.currentUpdate(this.platformId, 1, 4)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    altitude () {
      const update = this.currentUpdate(this.platformId, 1, 5)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    velocity_z () {
      const update = this.currentUpdate(this.platformId, 1, 7)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    dive_stage () {
      const update = this.currentUpdate(this.platformId, 4, 1)
      if (typeof update[1] !== 'undefined') {
        return this.capitalizeFirstLetter(update[1])
      }
      return '-'
    },
    position_source () {
      const update = this.currentUpdate(this.platformId, 1, 8)
      if (typeof update[1] !== 'undefined') {
        update[1] = update[1].replace('_', ' ')
        return update[1] !== 'USBL' ? this.capitalizeFirstLetter(update[1]).replace('_', ' ') : update[1]
      }
      return '-'
    },
    releaser_state () {
      const update = this.currentUpdate(this.platformId, 4, 3)
      if (typeof update[1] !== 'undefined') {
        return this.capitalizeFirstLetter(update[1])
      }
      return '-'
    },
    battery_voltage () {
      const update = this.currentUpdate(this.platformId, 3, 1)
      return (update.length !== 0) ? Number(update[1]) : 0
    },
    battery_warning () {
      const update = this.currentUpdate(this.platformId, 3, 2)
      return (update.length !== 0) ? (String(update[1]).toLowerCase() === 'true') : false
    },
    modem_error () {
      const update = this.currentUpdate(this.platformId, 2, 2)
      return (update.length !== 0) ? (String(update[1]).toLowerCase() === 'true') : false
    },
    depth_error () {
      const update = this.currentUpdate(this.platformId, 2, 3)
      return (update.length !== 0) ? (String(update[1]).toLowerCase() === 'true') : false
    },
    software_error () {
      const update = this.currentUpdate(this.platformId, 2, 4)
      return (update.length !== 0) ? (String(update[1]).toLowerCase() === 'true') : false
    }
  }
}
</script>

<style lang="scss" scoped>

.parameter-box {
  padding: 10px 0 0 10px;
}
.parameter-box h4 {
  margin-bottom: 2px;
}
.parameter-box h5 {
  margin-bottom: 2px;
}
.parameter-name {
  font-size: 11px;
  color: #6c757d;
}
.state-box {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  vertical-align: bottom;
  border-radius: 2px;
  padding: 5px 2px 5px 2px;
}
.state-ok {
  background-color: #82E0AA;
  color: #186A3B;
}
.state-danger {
  background-color: #F1948A;
  color: #78281F;
}
.no-gutters {
  margin-right: 10px;
  margin-left: 10px;
  .col,
  [class*="col-"] {
    padding-right: 2px;
    padding-left: 2px;
  }
}
.btn-xs {
  font-size: 12px;
  text-align: center;
  vertical-align: bottom;
  border-radius: 2px;
  padding: 5px 8px 5px 8px;
}
.velocity-z {
  font-size: 15px;
}
</style>
